module.exports = __webpack_public_path__ + "static/media/busan_design_logo.ee431c68.png";